import { Box, Button, Paper, Stack, Text } from '@mantine/core';
import { useRef, useState, type FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useGetRestaurantCategory, useGetRestaurantDetails } from '../../services/restaurant/restaurant.service';
import CategoriesWithSearch from './CategoriesWithSearch';
import FoodItemsContainer from './FoodItemsContainer';
import InfoHeader from './InfoHeader';
import { useGetRestaurantMenuItems } from '../../services/restaurant/menu-items/restaurant-menu-items.service';
import { AxiosError } from 'axios';
import { IBaseResponse } from '../../typescript/interfaces/common.interface';
import { useGlobalContext } from '../../context/global-context';
import { useCookies } from 'react-cookie';
import NoMenuItems from './NoMenuItems';
import { IconInfoCircle } from '@tabler/icons-react';
// import { AlertCircle, X } from 'lucide-react';

const RestaurantDetails: FC = () => {
  const location = useLocation();
  const restaurantInfo = location.state?.restaurantInfo;
  const [cookies] = useCookies(['session_token']);

  const { restaurantId } = useParams<{ restaurantId: string }>();
  const [category, setCategory] = useState({
    name: 'all',
    id: 0,
  });

  const { data, isSuccess, isLoading, isError, error, isFetchingNextPage, refetch } = useGetRestaurantMenuItems({
    enableIf: restaurantId !== undefined && !!cookies.session_token,
    restaurantId: restaurantId!,
  });

  const menuItems = data?.pages[0]?.data?.menu_items;
  const restaurantDetails = data?.pages[0]?.data?.restaurant_details;

  // const { data: restaurantData, isLoading: restaurantDataIsLoading } = useGetRestaurantDetails({
  //   enableIf: restaurantInfofromURLState,
  //   restaurantId: restaurantId!,
  // });
  // const [restaurantInfo, setRestaurantInfo] = useState(restaurantInfofromURLState.restaurantId ? restaurantInfofromURLState.restaurantId : restaurantData);

  const {
    data: restaurantCategoryData,
    isLoading: restaurantCategoryDataIsLoading,
    isSuccess: isCategorySuccess,
  } = useGetRestaurantCategory({
    enableIf: restaurantId !== undefined,
    restaurantId: restaurantId!,
  });
  const foodItemRefs = useRef<Array<HTMLDivElement | null>>([]);

  return (
    <>
      <InfoHeader
        data={restaurantInfo}
        restaurantDetails={restaurantDetails}
        isLoading={isLoading}
        isCategorySuccess={isCategorySuccess}
      />

      <CategoriesWithSearch
        data={restaurantCategoryData}
        isLoading={restaurantCategoryDataIsLoading}
        category={category}
        setCategory={setCategory}
        foodItemRefs={foodItemRefs}
      />

      <Box style={{ paddingInline: 16 }}>
        {/* <Text fw={600} mt={10} c='white' style={{ textTransform: 'uppercase' }}>
          {category.name} Items
        </Text> */}

        {Array.isArray(menuItems) && !menuItems?.length && <NoMenuItems my={20} />}

        {!isLoading && !restaurantDetails?.is_tax_registered && (
          <Paper
            mt={12}
            mb={8}
            px={0}
            py={0}
            radius='md'
            style={{
              background: 'linear-gradient(180deg, #FFF7ED 0%, #FFFBF5 100%)',
              border: '1px solid #FBD5B5',
              borderLeft: '3px solid #FF5A2F',
              boxShadow: '0 8px 20px rgba(255, 90, 47, 0.12)',
              overflow: 'hidden',
            }}>
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                padding: '12px 14px',
              }}>
              <Box style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                <IconInfoCircle stroke={2} color='#FF5A2F' size={16} />
                <Text fw={700} fz='sm' c='#7A2E1F'>
                  This restaurant is currently not taking any orders.
                </Text>
              </Box>
            </Box>
          </Paper>
        )}

        {Array.isArray(menuItems) && !!menuItems?.length && (
          <FoodItemsContainer
            restaurantInfo={restaurantInfo}
            category={category.id}
            // category={category}
            setCategory={setCategory}
            foodItemRefs={foodItemRefs}
            menuItems={menuItems}
            isMenuItemsFetchingNextPage={isFetchingNextPage}
            isMenuItemsLoading={isLoading}
            isMenuItemsSuccess={isSuccess}
            isMenuItemsDisabled={!restaurantDetails?.is_tax_registered}
          />
        )}
      </Box>
    </>
  );
};

export default RestaurantDetails;
